<template>
    <div class="vzhlad">
        <h5>{{ $t('offer.design_color_title') }}
            <paid-modal-icon v-if="!is_paid" :openModal="openModal" @close="openModal = false"/>
        </h5>
        <p>{{ $t('offer.design_later') }}</p>
        <div class="">
            <div  class="colors-pallete mb-3">
                <div @click="changeColor(color)" class="button"
                    :class="{ active: hexa == color && !own_color }" v-for="color in colors" :key="color.id">
                    <div :style="'background: ' + color" class="color"></div>
                </div>
                <div @click="is_paid ? own_color = true : openModal = true" class="button_own" :class="{ active: own_color }">
                    {{ $t('offer.design_custom_color') }}
                </div>
            </div>
            <div v-show="own_color" class="c-range">
                <div class="left">
                    <div :style="'background-color: ' + hexa" class="circle_colorpallet"></div>
                    <div class="sliders">
                        <div class="c-range__holder mb-2">
                            <input v-model.number="degrees" class="c-range__slider js-range-input" id="hue" type="range"
                                min="0" max="360" />
                        </div>
                        <div class="c-range__holder_white_black">
                            <input v-model.number="rgb" class="c-range__slider_white_black js-range-input" id="hue"
                                type="range" min="0" max="255" />
                        </div>
                    </div>
                </div>
                <div class="right">
                    <input v-model="hexa" placeholder="#fffffff" class="hex-input" type="text" />
                </div>
            </div>
            <div v-if="is_paid" class="d-flex">
                <div class="form-group d-flex mb-4 mt-5" style="align-items: flex-end">
                    <input v-model="dark" type="checkbox" class="toggle" />
                    <label class="block" @click="dark = !dark" style="cursor: pointer">
                        Dark mode
                    </label>
                </div>
                <div v-if="user_template == 0" class="form-group d-flex mb-4 mt-5 ml-4" style="align-items: flex-end">
                    <input v-model="compact_version" type="checkbox" class="toggle" />
                    <label class="block" @click="compact_version = !compact_version" style="cursor: pointer">
                        <div class="info ml-3 w-100">
                            <div class="my_tooltip">
                                {{ $t('offer.design_compact_hint') }}
                            </div>
                            <div class="tooltip_hover info_icon">
                                <img src="/img/info_icon.svg" alt="" />
                            </div>
                        </div>
                        {{ $t('offer.design_compact_label') }}
                    </label>
                </div>
            </div>
            <div v-else class="d-flex">
                <div class="form-group d-flex mb-4 mt-5" style="align-items: flex-end">
                    <input type="checkbox" class="toggle" :checked="false" @click.prevent="openModal = true"/>
                    <label class="block"  style="cursor: pointer" @click="openModal = true">
                        Dark mode
                    </label>
                </div>
                <div class="form-group d-flex mb-4 mt-5 ml-4" style="align-items: flex-end">
                    <input  type="checkbox" class="toggle" :checked="false" @click.prevent="openModal = true"/>
                    <label class="block" style="cursor: pointer" @click="openModal = true">
                        <div class="info ml-3 w-100">
                            <div class="my_tooltip">
                                {{ $t('offer.design_compact_hint') }}
                            </div>
                            <div class="tooltip_hover info_icon">
                                <img src="/img/info_icon.svg" alt="" />
                            </div>
                        </div>
                        {{ $t('offer.design_compact_label') }}
                    </label>
                </div>
            </div>
            <div class="result">
                <color-image :hexa="hexa" :dark="dark" />
            </div>
            <div v-if="is_paid">
                <div class="form-group d-flex mb-4 mt-4" style="align-items: flex-end">
                    <input v-model="footer_logo" type="checkbox" class="toggle" />
                    <label class="block" @click="footer_logo = !footer_logo" style="cursor: pointer">
                        <div class="info ml-3 w-100">
                            <div class="my_tooltip">
                                {{ $t('offer.design_hide_logo_hint') }}
                                logo v ponuke. Je teda na tebe, či nás podporíš.
                                :)
                            </div>
                            <div class="tooltip_hover info_icon">
                                <img src="/img/info_icon.svg" alt="" />
                            </div>
                        </div>
                        Skryť logo DOFFERO
                    </label>
                </div>
            </div>
            <div v-else class="noPremium" style="margin-top: 60px">
                <div class="form-group d-flex mb-4 mt-4 align-items-center" >
                    <input type="checkbox" class="toggle" :checked="false" @click.prevent="openModal = true"/>
                    <label class="block" style="cursor: pointer" @click="openModal = true">
                        Skryť logo DOFFERO
                    </label>
                    <paid-modal-icon v-if="!is_paid" :openModal="openModal" @close="openModal = false"/>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {EventBus} from "./EventBus.js";
import ColorImage from "../../premium/custom_color/components/ColorImage.vue";  
import PaidModalIcon from "../../vue_components/PaidModalIcon.vue";
export default {
    components: { ColorImage, PaidModalIcon },
    props: ["offercolor", "premium", "styleRows", "new_offer", "user_template"],
    data() {
        return {
            degrees: 180,
            hexa: "#F3385A",
            rgb: null,
            colors: [
                "#F3385A",
                "#FF551F",
                "#FFE299",
                "#6CC65E",
                "#A4E6F4",
                "#3960C6",
                "#BD00FF",
                "#A40000",
                "#B3B3B3",
                "#000000",
            ],
            own_color: false,
            dark: false,
            footer_logo: false,
            template_type: 0,
            compact_version: 0,
            is_paid: false,
            openModal: false,
        };
    },
    methods: {
        changeColor(color){
            if(this.is_paid){
                this.hexa = color;
                this.own_color = false;
            }else{
                this.openModal = true;
            }
        },
        hslToHex() {
            var s = 100;
            var l = 50;
            var h = this.degrees;
            h /= 360;
            s /= 100;
            l /= 100;
            let r, g, b;
            if (s === 0) {
                r = g = b = l; // achromatic
            } else {
                const hue2rgb = (p, q, t) => {
                    if (t < 0) t += 1;
                    if (t > 1) t -= 1;
                    if (t < 1 / 6) return p + (q - p) * 6 * t;
                    if (t < 1 / 2) return q;
                    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
                    return p;
                };
                const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
                const p = 2 * l - q;
                r = hue2rgb(p, q, h + 1 / 3);
                g = hue2rgb(p, q, h);
                b = hue2rgb(p, q, h - 1 / 3);
            }
            const toHex = (x) => {
                const hex = Math.round(x * 255).toString(16);
                return hex.length === 1 ? "0" + hex : hex;
            };
            this.hexa = `#${toHex(r)}${toHex(g)}${toHex(b)}`;
        },
        componentToHex() {
            var rgb = 255 - this.rgb;
            var hex = rgb.toString(16);
            return hex.length == 1 ? "0" + hex : hex;
        },
        rgbToHex() {
            this.hexa =
                "#" +
                this.componentToHex() +
                this.componentToHex() +
                this.componentToHex();
        },
    },
    mounted() {
        if (this.offercolor) this.hexa = this.offercolor;
        else this.hexa = "#F3385A";
        EventBus.$on('is_paid', (val) => {
            this.is_paid = val;
        });
    },
    watch: {
        "premium.offerColor": function () {
            if (this.styleRows.color == null) {
                if (this.is_paid) {
                    this.hexa = this.premium.offerColor
                    if (!this.colors.includes(this.hexa)) {
                        this.own_color = true;
                    }
                }else{
                    this.hexa = "#F3385A";
                }
            }
        },
        "premium.offer_footer_logo": function () {
            if (this.new_offer) {
                if (this.premium.offer_footer_logo) this.footer_logo = true;
            }
        },
        "styleRows.compact_version": function () {
            this.compact_version = this.styleRows.compact_version;
        },
        "styleRows.color": function () {
            if (this.styleRows.color != null && this.is_paid) {
                this.hexa = this.styleRows.color;
                if (!this.colors.includes(this.styleRows.color)) {
                    this.own_color = true;
                }
            }
        },
        "styleRows.lang": function () {
            this.lang = this.styleRows.lang;
            if (this.styleRows.lang == "en") {
                this.lang_check = true;
            }
        },
        "styleRows.dark": function () {
            if (this.styleRows.dark == 1) this.dark = true;
        },
        "styleRows.footer_logo": function () {
            if (!this.new_offer) {
                if (this.styleRows.footer_logo == 1) this.footer_logo = true;
            }
        },
        "styleRows.template_type": function () {
            if (this.styleRows.template_type)
                this.template_type = this.styleRows.template_type;
        },
        degrees() {
            this.hslToHex();
        },
        rgb() {
            this.rgbToHex();
        },
        hexa() {
            var data = {
                hexa: this.hexa,
                dark: this.dark,
                footer_logo: this.footer_logo,
                compact_version: this.compact_version,
                template_type: this.template_type,
            };
            this.$emit("getData", data);
        },
        offercolor() {
            if (this.offercolor) this.hexa = this.offercolor;
        },
        footer_logo() {
            var data = {
                hexa: this.hexa,
                dark: this.dark,
                footer_logo: this.footer_logo,
                compact_version: this.compact_version,
                template_type: this.template_type,
            };
            this.$emit("getData", data);
        },
        dark() {
            var data = {
                hexa: this.hexa,
                dark: this.dark,
                footer_logo: this.footer_logo,
                compact_version: this.compact_version,
                template_type: this.template_type,
            };
            this.$emit("getData", data);
        },
        compact_version() {
            var data = {
                hexa: this.hexa,
                dark: this.dark,
                footer_logo: this.footer_logo,
                compact_version: this.compact_version,
                template_type: this.template_type,
            };
            this.$emit("getData", data);
        },
        template_type() {
            var data = {
                hexa: this.hexa,
                dark: this.dark,
                footer_logo: this.footer_logo,
                compact_version: this.compact_version,
                template_type: this.template_type,
            };
            this.$emit("getData", data);
        },
        own_color() {
            if (this.own_color) {
                if (this.rgb != null) this.rgbToHex();
            }
        },
    },
    created() {
        this.hslToHex();
    },
};
</script>

<style lang="scss" scoped>
.noPremium {
    margin-top: 50px;
    position: relative;
    width: 520px;

    @media screen and (max-width: 700px) {
        width: auto;
    }

    img {
        opacity: 0.4;

        @media screen and (max-width: 700px) {
            width: 100%;
        }
    }

    .ColorBox {
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        margin: auto;
        width: 510px;
        height: 41px;
        background: #fff7ed;
        border: 1px solid #fbbf24;
        box-sizing: border-box;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;

        @media screen and (max-width: 700px) {
            width: auto;
            height: fit-content;
            padding: 5px;
        }

        svg {
            width: 21px;
            height: 14px;
            margin-right: 13px;
        }

        div {
            font-family: Roboto;
            font-style: normal;
            font-weight: 400;
            font-size: 16px;
            line-height: 19px;
            color: #9a3412;

            b {
                font-weight: 600;
            }

            a {
                font-weight: 600;
                text-decoration: underline;
                color: #9a3412;

                &:hover {
                    color: #9a3412;
                    text-decoration: underline;
                }
            }
        }
    }
}

.info {
    position: relative;
    height: 20px;

    .info_icon {
        pointer-events: all;
        cursor: pointer;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 20px;
        height: 20px;
        float: right;

        img {
            width: 80%;
            height: 80%;
        }

        @media (max-width: 400px) {
            float: none;
            margin-left: auto;
            margin-right: 35px;
        }
    }

    .my_tooltip {
        bottom: 21px;
        right: -7px;
        max-width: 250px;
    }
}

.agree_tooltip {
    position: relative;
}

.my_tooltip {
    pointer-events: none;
    opacity: 0;
    text-align: center;
    z-index: 2000 !important;
    display: grid;
    align-items: center;
    justify-content: center;
    width: max-content;
    background: #f3385a;
    box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
    border-radius: 6px;
    font-weight: 800;
    font-size: 15px;
    line-height: 18px;
    color: #fff;
    padding: 10px;
    position: absolute;
    top: unset;
    right: 15px;
    z-index: 10;
    transition: opacity 0.5s ease-in-out;

    img {
        margin-top: 5px;
        width: 340px;
        height: 215px;
    }

    &::after {
        content: "";
        width: 11px;
        height: 11px;
        background: #f3385a;
        position: absolute;
        right: 12px;
        bottom: -3px;
        -webkit-transform: rotate(45deg);
        transform: rotate(45deg);
        border-radius: 3px;
    }
}

.vzhlad {
    width: 100%;
    height: auto;
    background: #ffffff;
    box-shadow: 0px 4px 15px rgba(0, 0, 0, 0.05);
    border-radius: 4px;
    padding: 30px;
    margin-bottom: 20px;

    h5 {
        font-family: Roboto;
        font-style: normal;
        font-weight: bold;
        font-size: 18px;
        line-height: 21px;
        color: #212541;
        display: flex;
        align-items: center;
        gap: 10px;
    }

    p {
        margin: 12px 0 20px 0;

        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #9598a7;
    }

    label {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;

        color: #212541;
        margin-bottom: 0;

        @media (max-width: 400px) {
            font-size: 13px;
        }

        @media (max-width: 600px) {
            width: 70%;
        }
    }

    input[type="checkbox"] {
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-tap-highlight-color: transparent;
        cursor: pointer;
        margin: 0px 10px 0 0;
        background: #c7d4eb;
        border-radius: 25px;
    }

    input[type="checkbox"]:focus {
        outline: 0;
    }

    .toggle {
        height: 22px;
        width: 40px;
        display: inline-block;
        position: relative;
        margin: 0;
        border: none;
        background: #ffffff;
        border-radius: 3px;
        transition: all 0.2s ease;
    }

    .toggle:after {
        content: "";
        position: absolute;
        top: 4px;
        left: 3px;
        width: 14px;
        height: 14px;
        border-radius: 50%;
        background: white;
        box-shadow: 0 1px 2px rgba(44, 44, 44, 0.2);
        transition: all 0.2s cubic-bezier(0.5, 0.1, 0.75, 1.35);
    }

    .toggle:checked {
        border-color: #2ed8b6;
        background: #2ed8b6;
    }

    .toggle:checked:after {
        transform: translatex(20px);

        @media (max-width: 350px) {
            transform: translatex(12px);
        }

        @media (max-width: 500px) and (min-width: 351px) {
            transform: translatex(16px);
        }
    }

    svg {
        width: 889px;
        height: 676px;

        @media screen and (max-width: 1050px) {
            width: 100%;
        }
    }

    $track-h: 14px;
    $track-h-wb: 5px;
    $thumb-d: 13px;

    @mixin track_black_white() {
        border: none;
        width: 100%;
        height: $track-h-wb;
        border-radius: 4px;
        background: linear-gradient(to right, white 0%, black 100%);
    }

    @mixin track() {
        border: none;
        width: 100%;
        height: $track-h;
        border-radius: 4px;
        background: linear-gradient(to right,
                #ff0000 0%,
                #ffff00 17%,
                #00ff00 33%,
                #00ffff 50%,
                #0000ff 67%,
                #ff00ff 83%,
                #ff0000 100%);
    }

    @mixin thumb() {
        border: 2px solid black;
        width: $thumb-d;
        height: $thumb-d;
        border-radius: 50%;
        background: transparent;
        box-shadow: var(--box-shadow);
    }

    .heading-colors {
        width: 100%;
        margin: 27px auto 15px auto;

        @media screen and (max-width: 600px) {
            width: 100%;
            text-align: center;
        }

        span {
            font-family: Roboto;
            font-style: normal;
            font-weight: bold;
            font-size: 16px;
            line-height: 19px;
            color: #263544;
        }
    }

    .result {
        width: 96%;
        border: 1px solid #dde3e8;
        padding: 20px 0px;

        @media screen and (max-width: 600px) {
            width: 100%;
            text-align: center;
        }

        div {
            font-family: Roboto;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 150%;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #404040;
            margin-bottom: 8px;
        }

        svg {
            @media screen and (max-width: 600px) {
                width: 90%;
                margin: 0 auto;
                display: block;
                height: 200px;
            }
        }
    }

    .colors-pallete {
        background: transparent;
        display: flex;
        width: 100%;
        margin: 0 auto;

        & {
            @media screen and (max-width: 600px) {
                flex-wrap: wrap;
                gap: 18px;
                align-items: center;
                justify-content: center;
                width: 95%;
            }
        }

        .button.active {
            border: 1px solid #000000;
            box-sizing: border-box;
            box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
            border-radius: 3px;
            position: relative;

            &:after {
                content: "";
                background: url("/img/create_offer/check.svg") no-repeat center;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background-color: black;
                position: absolute;
                right: -5px;
                top: -5px;
            }
        }

        .button {
            background: #ffffff;
            border-radius: 3px;
            border: 1px solid transparent;
            width: 40px;
            height: 40px;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            box-shadow: 0px 2px 2px rgba(143, 153, 179, 0.2);
            margin-right: 25px;

            .color {
                width: 20px;
                height: 20px;
                border: 1px solid #e4eaef;
                box-sizing: border-box;
                border-radius: 4px;
            }

            @media (max-width: 600px) {
                margin-right: 0px !important;
            }
        }

        .button_own.active {
            border: 1px solid #000000;
            position: relative;

            &:after {
                content: "";
                background: url("/img/create_offer/check.svg") no-repeat center;
                width: 14px;
                height: 14px;
                border-radius: 50%;
                background-color: black;
                position: absolute;
                right: -5px;
                top: -5px;
            }
        }

        .button_own {
            background: #ffffff;
            border: 1px solid #dde3e8;
            box-sizing: border-box;
            box-shadow: 0px 2px 2px rgb(143 153 179 / 20%);
            border-radius: 3px;
            width: 120px;
            height: 40px;
            font-style: normal;
            font-weight: normal;
            font-size: 14px;
            line-height: 16px;
            color: #212541;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
        }
    }

    .or {
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #263544;
    }

    .c-range {
        display: flex;
        width: 100%;
        margin: 0 auto;

        @media only screen and (max-width: 600px) {
            width: 95%;
            display: block;
        }

        position: relative;
        background: transparent;
        border-radius: var(--border-radius);
        display: flex;

        .right {
            @media only screen and (max-width: 600px) {
                display: block;
                text-align: center;
                margin-top: 25px;
            }
        }

        .left {
            display: flex;
            align-items: center;
            height: 50px;
            margin-right: 25px;
            background: #ffffff;
            border-radius: 3px;

            @media only screen and (max-width: 600px) {
                width: 100%;
            }

            .circle_colorpallet {
                width: 35px;
                height: 35px;
                border-radius: 50%;
                background-color: var(--color-alpha);
                margin-right: 30px;
            }

            .sliders {
                .c-range__holder_white_black {
                    display: flex;
                    align-items: center;
                    position: relative;
                    width: 170px;

                    .c-range__slider_white_black {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        min-height: $thumb-d;
                        background: transparent;
                        outline: none;

                        &,
                        &::-webkit-slider-thumb {
                            -webkit-appearance: none;
                        }

                        &::-webkit-slider-runnable-track {
                            @include track_black_white();
                        }

                        &::-moz-range-track {
                            @include track_black_white;
                        }

                        &::-ms-track {
                            @include track_black_white;
                        }

                        &::-webkit-slider-thumb {
                            margin-top: 0.5 * ($track-h-wb - $thumb-d);
                            @include thumb;
                        }

                        &::-moz-range-thumb {
                            @include thumb;
                        }

                        &::-ms-thumb {
                            margin-top: 0;
                            @include thumb;
                        }

                        &::-ms-tooltip {
                            display: none;
                        }

                        &:focus,
                        &:active {
                            +.c-range__output {
                                opacity: 1;
                            }
                        }
                    }
                }

                .c-range__holder {
                    display: flex;
                    align-items: center;
                    position: relative;
                    width: 170px;

                    .c-range__slider {
                        width: 100%;
                        margin: 0;
                        padding: 0;
                        min-height: $thumb-d;
                        background: transparent;
                        outline: none;

                        &,
                        &::-webkit-slider-thumb {
                            -webkit-appearance: none;
                        }

                        &::-webkit-slider-runnable-track {
                            @include track();
                        }

                        &::-moz-range-track {
                            @include track;
                        }

                        &::-ms-track {
                            @include track;
                        }

                        &::-webkit-slider-thumb {
                            margin-top: 0.5 * ($track-h - $thumb-d);
                            @include thumb;
                        }

                        &::-moz-range-thumb {
                            @include thumb;
                        }

                        &::-ms-thumb {
                            margin-top: 0;
                            @include thumb;
                        }

                        &::-ms-tooltip {
                            display: none;
                        }

                        &:focus,
                        &:active {
                            +.c-range__output {
                                opacity: 1;
                            }
                        }
                    }
                }
            }
        }
    }

    .hex-input {
        background: #ffffff;
        border: 1px solid #dde3e8;
        border-radius: 3px;
        width: 198px;
        height: 50px;
        padding: 12px 21px;
        font-family: Roboto;
        font-style: normal;
        font-weight: normal;
        font-size: 14px;
        line-height: 16px;
        color: #212541;
        margin-left: 15px;
        text-transform: uppercase;
    }

    .hex-input::-webkit-input-placeholder {
        /* Edge */
        color: rgba(33, 37, 65, 0.3);
    }

    .hex-input:-ms-input-placeholder {
        /* Internet Explorer */
        color: rgba(33, 37, 65, 0.3);
    }

    .hex-input::placeholder {
        color: rgba(33, 37, 65, 0.3);
    }

    @media screen and (max-width: 640px) {}
}
</style>
